import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landing",
    component: () => import("@/views/Landing/Landing.vue"),
    meta: {
      layout: "blank",
      title: "Landing",
    },
  },
  {
    path: "/contactanos",
    name: "contact",
    component: () => import("@/views/Landing/Contact.vue"),
    meta: {
      layout: "blank",
      title: "Contáctanos",
    },
  },
  {
    path: "/thank-you-registration",
    name: "thank-you-registration",
    component: () => import("@/views/Landing/ThankYouRegistration.vue"),
    meta: {
      layout: "blank",
      title: "Gracias por registrarte",
    },
  },
  {
    path: "/dashboards",
    name: "dashboards",
    component: () => import("@/views/Dashboards/Dashboards.vue"),
    meta: {
      layout: "content",
      title: "Dashboards",
      requiresAuth: true,
    },
  },
  {
    path: "/running_trips",
    name: "runningTrips",
    component: () => import("@/views/RunningTrips/RunningTrips.vue"),
    meta: {
      layout: "content",
      title: "Running trips",
      requiresAuth: true,
      forbiddenMaster: true,
      requiresCanCreateTrips: true,
    },
  },
  {
    path: "/multistop",
    name: "multiStop",
    component: () => import("@/views/Multistop/Multistop.vue"),
    meta: {
      layout: "content",
      title: "Multistop",
      requiresAuth: true,
      requiresMultiStop: true,
      forbiddenMaster: true,
    },
  },
  {
    path: "/multistop/new",
    name: "multiStopNew",
    component: () => import("@/views/Multistop/actions/Edit.vue"),
    meta: {
      layout: "content",
      title: "multiStopNew",
      requiresAuth: true,
      requiresMultiStop: true,
      forbiddenMaster: true,
    },
  },
  {
    path: "/multistop/:id",
    name: "multiStopShow",
    component: () => import("@/views/Multistop/actions/Show.vue"),
    meta: {
      layout: "content",
      title: "MultistopShow",
      requiresAuth: true,
      requiresMultiStop: true,
    },
  },
  {
    path: "/history",
    name: "history",
    component: () => import("@/views/History/History.vue"),
    meta: {
      layout: "content",
      title: "History",
      requiresAuth: true,
      forbiddenMaster: true,
    },
  },
  {
    path: "/running_parcels",
    name: "runningParcels",
    component: () => import("@/views/Parcel/RunningParcels.vue"),
    meta: {
      layout: "content",
      title: "Running parcels",
      requiresAuth: true,
      requiresParcel: true,
      forbiddenMaster: true,
      requiresCanCreateTrips: true,
    },
  },
  {
    path: "/parcel_history",
    name: "parcelHistory",
    component: () => import("@/views/ParcelHistory/History.vue"),
    meta: {
      layout: "content",
      title: "parcelHistory",
      requiresAuth: true,
      requiresParcel: true,
      forbiddenMaster: true,
    },
  },
  // {
  //   path: "/parcel_multistop",
  //   name: "parcelMultiStop",
  //   component: () => import("@/views/ParcelMultistop/ParcelMultistop.vue"),
  //   meta: {
  //     layout: "content",
  //     title: "ParcelMultistop",
  //     requiresAuth: true,
  //     requiresParcel: true,
  //   },
  // },
  // {
  //   path: "/parcel_multistop/new",
  //   name: "parcelMultiStopNew",
  //   component: () => import("@/views/ParcelMultistop/actions/Edit.vue"),
  //   meta: {
  //     layout: "content",
  //     title: "parcelMultiStopNew",
  //     requiresAuth: true,
  //     requiresParcel: true,
  //   },
  // },
  {
    path: "/parcel_multistop/:id",
    name: "parcelMultiStopShow",
    component: () => import("@/views/ParcelMultistop/actions/Show.vue"),
    meta: {
      layout: "content",
      title: "parcelMultiStopShow",
      requiresAuth: true,
      requiresParcel: true,
    },
  },
  {
    path: "/corporate_users",
    name: "users",
    component: () => import("@/views/Users/Users.vue"),
    meta: {
      layout: "content",
      title: "Users",
      requiresAuth: true,
      forbiddenMaster: true,
    },
  },
  // Deprecated by https://ridery-app.atlassian.net/servicedesk/customer/portal/5/SPR-2544
  // {
  //   path: "/corporate_panels",
  //   name: "corporatePanels",
  //   component: () => import("@/views/CorporatePanels/CorporatePanels.vue"),
  //   meta: {
  //     layout: "content",
  //     title: "CorporatePanels",
  //     requiresAuth: true,
  //     requiresMaster: true,
  //   },
  // },
  {
    path: "/balance",
    name: "balance",
    component: () => import("@/views/Balance/Balance.vue"),
    meta: {
      layout: "content",
      title: "Balance",
      requiresAuth: true,
      forbiddenMaster: true,
    },
  },
  {
    path: "/corporate_invoices",
    name: "corporateInvoices",
    component: () => import("@/views/CorporateInvoices/CorporateInvoices.vue"),
    meta: {
      layout: "content",
      title: "CorporateInvoices",
      requiresAuth: true,
      forbiddenMaster: false,
    },
  },
  {
    path: "/invoices-to-pay",
    name: "invoicesToPay",
    component: () => import("@/views/CorporateInvoices/CorporateInvoicesToPay.vue"),
    meta: {
      layout: "content",
      title: "InvoicesToPay",
      requiresAuth: true,
    },
  },
  {
    path: "/islr-retention",
    name: "islrRetention",
    component: () => import("@/views/CorporateInvoices/IslrRetention.vue"),
    meta: {
      layout: "content",
      title: "IslrRetention",
      requiresAuth: true,
    },
  },
  {
    path: "/corporate_invoices/:id",
    name: "corporateInvoiceDetails",
    component: () => import("@/views/CorporateInvoices/CorporateInvoicesDetails.vue"),
    meta: {
      layout: "content",
      title: "CorporateInvoiceDetails",
      requiresAuth: true,
    },
  },
  {
    path: "/rentals",
    name: "rentals",
    component: () => import("@/views/Rentals/Rentals.vue"),
    meta: {
      layout: "content",
      title: "Rentals",
      requiresAuth: true,
      forbiddenMaster: true,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/Profile/Profile.vue"),
    meta: {
      layout: "content",
      title: "Profile",
      requiresAuth: true,
    },
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("@/views/Faq/Faq.vue"),
    meta: {
      layout: "content",
      title: "Faq",
      requiresAuth: true,
    },
  },
  {
    path: "/",
    component: () => import("@/layouts/auth/AuthLayout.vue"),
    meta: {
      layout: "blank",
    },
    children: [
      {
        path: "login",
        name: "auth-login",
        component: () => import("@/views/Login/Login.vue"),
        meta: {
          layout: "blank",
          title: "Login",
          authLayoutVariant: "login",
        },
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        component: () => import("@/views/ForgotPassword/ForgotPassword.vue"),
        meta: {
          layout: "blank",
          title: "ForgotPassword",
          authLayoutVariant: "forgotPassword",
        },
      },
      {
        path: "billing-info",
        name: "BillingInfo",
        component: () => import("@/views/BillingInfo/BillingInfo.vue"),
        meta: {
          layout: "blank",
          title: "Billing Info",
          requiresAuth: true,
        },
        beforeEnter: (_, __, next) => {
          // Prevenir navegacion manual a la vista de datos de facturacion
          const isBillingIncomplete = store.state.auth.is_billing_incomplete;
          if (!isBillingIncomplete) return next({ name: 'dashboards' });
          return next();
        },
      },
    ],
  },
  {
    path: "/change-expired-password",
    name: "ChangeExpiredPassword",
    component: () =>
      import("@/views/ChangeExpiredPassword/ChangeExpiredPassword.vue"),
    meta: {
      layout: "blank",
      title: "ChangeExpiredPassword",
      requiresAuth: true,
      allowExpiredPassword: true,
    },
  },
  {
    path: "/invoice/:id",
    name: "invoice",
    component: () => import("@/views/Invoice/Invoice.vue"),
    meta: {
      layout: "content",
      title: "Invoice",
      requiresAuth: true,
    },
  },
  {
    path: "/user/:id",
    name: "user",
    component: () => import("@/views/User/User.vue"),
    meta: {
      layout: "content",
      title: "User",
      requiresAuth: true,
    },
  },
  {
    path: "/corporate_panel/:id",
    name: "corporatePanel",
    component: () => import("@/views/CorporatePanel/CorporatePanel.vue"),
    meta: {
      layout: "content",
      title: "CorporatePanel",
      requiresAuth: true,
      requiresMaster: true,
    },
  },
  {
    path: "/provider/:id",
    name: "provider",
    component: () => import("@/views/Provider/Provider.vue"),
    meta: {
      layout: "content",
      title: "Provider",
      requiresAuth: true,
    },
  },
  {
    path: "/view-map/:id",
    name: "ViewMap",
    component: () => import("@/views/ViewMap/ViewMap.vue"),
    meta: {
      layout: "content",
      title: "ViewMap",
      requiresAuth: true,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword/ResetPassword.vue"),
    meta: {
      layout: "blank",
      title: "ResetPassword",
    },
  },
  {
    path: "*",
    name: "Error",
    component: () => import("@/views/Error404.vue"),
    meta: {
      layout: "blank",
      title: "Error",
    },
  },
  {
    path: "/billing-mode-assistance",
    name: "billing-mode-assistance",
    component: () =>
      import("@/views/BillingModeAssistance/BillingModeAssistance.vue"),
    meta: {
      layout: "blank",
      title: "Billing mode assistance",
    },
  },
  {
    path: "/not-in-panel",
    name: "NotInPanel",
    component: () => import("@/views/NotInPanel.vue"),
    meta: {
      layout: "blank",
      title: "Error",
    },
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: () => import("@/views/ErrorForbidden.vue"),
    meta: {
      layout: "blank",
      title: "Forbidden",
    },
  },
  {
    path: "/parcel-guide",
    name: "ParcelGuide",
    component: () => import("@/views/ParcelGuide.vue"),
    meta: {
      layout: "blank",
      title: "ParcelGuide",
      requiresAuth: false,
    },
  },
  {
    path: "/trip-info/:id",
    name: "TripInfo",
    component: () => import("@/views/TripInfo/ViewMap.vue"),
    meta: {
      layout: "blank",
      title: "TripInfo",
      requiresAuth: true,
    },
  },
  {
    path: "/api-documentation",
    name: "ApiDocumentation",
    beforeEnter(_to, _from, next) {
      const isApiPartner = store.state.auth.is_corporate_api_partner;
      if (!isApiPartner) {
        return next({ name: "Forbidden" });
      }
      window.location.assign(
        "https://api-partner-docs.ridery.app/introduccion.html"
      );
      next(false);
    },
  },
  {
    path: "/assist-mode",
    name: "Assist Mode",
    component: () => import("@/views/AssistMode/AssistMode.vue"),
    meta: {
      layout: "blank",
      title: "Login",
    },
  },
  {
    path: "/cargo-logistics",
    name: "cargoLogistics",
    component: () => import("@/views/CargoLogistic/CargoLogistic.vue"),
    meta: {
      layout: "content",
      title: "cargoLogistics",
      requiresAuth: true,
      forbiddenMaster: true,
    },
  },
  {
    path: "/credit-distribution",
    name: "creditDistribution",
    component: () => import("@/views/CreditDistribution/CreditDistribution.vue"),
    meta: {
      layout: "content",
      title: "CreditDistribution",
      requiresAuth: true,
      requiresMaster: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// Cache para evitar llamadas excesivas al backend (TTL: 60 segundos)
let permissionsCache = { timestamp: 0, valid: false };
const PERMISSIONS_CACHE_TTL_MS = 60 * 1000;

function isPermissionsCacheValid() {
  return (
    permissionsCache.valid &&
    Date.now() - permissionsCache.timestamp < PERMISSIONS_CACHE_TTL_MS
  );
}

function invalidatePermissionsCache() {
  permissionsCache = { timestamp: 0, valid: false };
}

function markPermissionsCacheValid() {
  permissionsCache = { timestamp: Date.now(), valid: true };
}

let authHydrationPromise = null;

async function hydrateAuthFromToken() {
  if (store.state.auth.user || !store.state.auth.token) return true;

  if (!authHydrationPromise) {
    authHydrationPromise = store
      .dispatch("auth/meNotLoading")
      .then(() => true)
      .catch(() => {
        store.commit("auth/LOGOUT");
        invalidatePermissionsCache();
        return false;
      })
      .finally(() => {
        authHydrationPromise = null;
      });
  }

  return authHydrationPromise;
}

// Exponer para que el logout pueda invalidar el cache
export { invalidatePermissionsCache };

router.beforeEach(async (_to, _from, next) => {
  const token = store.state.auth.token;
  const requiresAuth = _to.matched.some((route) => route.meta.requiresAuth);
  const requiresParcel = _to.matched.some((route) => route.meta.requiresParcel);
  const requiresMultiStop = _to.matched.some(
    (route) => route.meta.requiresMultiStop
  );
  const requiresMaster = _to.matched.some((route) => route.meta.requiresMaster);
  const forbiddenMaster = _to.matched.some(
    (route) => route.meta.forbiddenMaster
  );
  const requiresCanCreateTrips = _to.matched.some(
    (route) => route.meta.requiresCanCreateTrips
  );

  // Authentication
  if (requiresAuth && !token) {
    invalidatePermissionsCache();
    return next({ name: "auth-login", query: { redirect: _to.fullPath } });
  }

  if (requiresAuth && token && !store.state.auth.user) {
    const authHydrated = await hydrateAuthFromToken();
    if (!authHydrated) {
      return next({ name: "auth-login", query: { redirect: _to.fullPath } });
    }
  }

  // Password-expiry guard — read user fresh from store (not the local variable
  // captured above) so that any async hydration that may run before this guard
  // is reflected correctly on the very first navigation.
  // Admins in assist mode are exempt; they navigate freely even on expired corporates.
  const currentUser = store.state.auth.user;
  const mustChange = store.state.auth.must_change_password;
  const isAssistMode = store.state.auth.is_assist_mode === true;
  const allowExpired = _to.matched.some((route) => route.meta.allowExpiredPassword);
  if (currentUser && mustChange && !isAssistMode && !allowExpired) {
    return next({ name: "ChangeExpiredPassword" });
  }
  // Prevent navigating to the change-password view when it is no longer needed
  if (currentUser && (!mustChange || isAssistMode) && _to.name === "ChangeExpiredPassword") {
    return next({ name: "dashboards" });
  }

  // Redirigir al formulario de facturacion cuando es necesario
  const isBillingIncomplete = store.state.auth.is_billing_incomplete;
  if (currentUser && isBillingIncomplete === true && _to.name !== 'BillingInfo')
    return next({ name: 'BillingInfo' });

  // Si la ruta requiere autenticación o permisos especiales, re-validar contra el backend
  const needsPermissionCheck =
    requiresAuth ||
    requiresParcel ||
    requiresMultiStop ||
    requiresMaster ||
    forbiddenMaster;

  if (token && needsPermissionCheck && !isPermissionsCacheValid()) {
    try {
      await store.dispatch("auth/refreshPermissions");
      markPermissionsCacheValid();
    } catch (e) {
      invalidatePermissionsCache();
      return next({ name: "auth-login", query: { redirect: _to.fullPath } });
    }
  }

  // Leer permisos actualizados desde el store (ya re-validados con el backend)
  const is_active_shipments = store.state.auth.is_active_shipments;
  const is_active_multi_stops = store.state.auth.is_active_multi_stops;
  const is_corporate_master = store.state.auth.is_corporate_master;

  if (requiresParcel && !is_active_shipments) {
    return next({ name: "Forbidden" });
  }

  if (requiresMultiStop && !is_active_multi_stops) {
    return next({ name: "Forbidden" });
  }

  if (requiresMaster && !is_corporate_master) {
    return next({ name: "Forbidden" });
  }

  if (forbiddenMaster && is_corporate_master) {
    return next({ name: "Forbidden" });
  }
  
  if (requiresCanCreateTrips) {
    const { canCreateTrips } = store.state.auth;
    if (!canCreateTrips) return next({ name: "dashboards" });
  }

  next();
});

export default router;
